const K = 0.18;
const W = 38;
const CX = 17;
const CAP_H = 305 * K;
const BANDS = [[0, 50, 'url(#TOP)'], [50, 3, '#8a8a8a'], [53, 45, '#1a1a1a'], [98, 3, '#555'], [101, 19, '#333'], [121, 26, '#3a3a3a'], [153, 6, '#ececec'], [163, 26, '#303030'], [191, 20, '#686868'], [213, 24, '#808080'], [239, 17, '#5c5c5c'], [256, 49, '#333']];

let syncing = false;
let uid = 0;

const ROW = '.pag-bp__row, .pag-bf__scrollwrap';
const scrollOf = (fader) => fader.closest(ROW).querySelector('[data-pag-scroll]');
const faderOf = (scroll) => scroll.closest(ROW).querySelector('[data-pag-fader]');
const room = (el) => Math.max(el.scrollHeight - el.clientHeight, 0);

const paint = (fader) => {
  const scroll = scrollOf(fader);
  const p = room(scroll) ? scroll.scrollTop / room(scroll) : 0;
  const cap = fader.querySelector('.pag-bp__cap');
  if (cap) cap.setAttribute('transform', `translate(${CX - 13.15} ${p * (fader.clientHeight - CAP_H)}) scale(${K})`);
  fader.setAttribute('aria-valuenow', Math.round(p * 100));
  fader.toggleAttribute('data-idle', !room(scroll));
};

const setPos = (fader, p) => {
  const scroll = scrollOf(fader);
  syncing = true;
  scroll.scrollTop = Math.min(1, Math.max(0, p)) * room(scroll);
  syncing = false;
  paint(fader);
};

const build = (fader) => {
  const H = fader.clientHeight;
  if (!H || fader.dataset.h === String(H)) return;
  fader.dataset.h = H;
  const id = `pbf${++uid}`;
  const n = Math.floor(H / 12);
  const mid = Math.round(n / 2);
  let ticks = '<g stroke="#bdbdbd" stroke-width="1.3">';
  for (let i = 0; i <= n; i++) {
    const y = i * 12 + 0.7;
    const major = i % 5 === 0;
    ticks += `<line x1="0" x2="${major ? 11 : 7}" y1="${y}" y2="${y}"/><line x1="${major ? 24 : 29}" x2="${W}" y1="${y}" y2="${y}"/>`;
  }
  ticks += `<line x1="0" x2="12" y1="${mid * 12 + 0.7}" y2="${mid * 12 + 0.7}" stroke-width="1.9"/></g>`;
  fader.innerHTML = `<svg width="${W}" height="${H}" viewBox="0 0 ${W} ${H}" aria-hidden="true" focusable="false"><defs>
    <linearGradient id="${id}-rail" x1="0" x2="1"><stop offset="0" stop-color="#818181"/><stop offset=".25" stop-color="#a0a0a0"/><stop offset=".5" stop-color="#777777"/><stop offset="1" stop-color="#696969"/></linearGradient>
    <linearGradient id="${id}-top" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="#555"/><stop offset="1" stop-color="#404040"/></linearGradient>
    <filter id="${id}-blur"><feGaussianBlur stdDeviation="3"/></filter><clipPath id="${id}-clip"><rect width="146" height="305" rx="9"/></clipPath></defs>${ticks}
    <rect x="${CX - 3}" width="6" height="${H}" rx="3" fill="url(#${id}-rail)"/>
    <g class="pag-bp__cap"><path d="M146 40 q30 14 24 50 q14 40 0 80 q14 40 0 90 l-24 -20z" fill="#8e8e8e" opacity=".75" filter="url(#${id}-blur)"/>
    <g clip-path="url(#${id}-clip)"><rect width="146" height="305" fill="#262626"/>${BANDS.map(([y, h, c]) => `<rect y="${y}" width="146" height="${h}" fill="${c.replace('#TOP', `#${id}-top`)}"/>`).join('')}</g>
    <rect x=".5" y=".5" width="145" height="304" rx="9" fill="none" stroke="#222" stroke-width="2"/></g></svg>`;
  paint(fader);
};

const observer = new ResizeObserver((entries) => entries.forEach((entry) => build(entry.target)));
const watch = () => document.querySelectorAll('[data-pag-fader]').forEach((fader) => {
  observer.observe(fader);
  if (!fader.querySelector('svg')) { delete fader.dataset.h; build(fader); }
});
watch();
// Header re-renders can empty or swap the fader without resizing it.
new MutationObserver(() => requestAnimationFrame(watch)).observe(document.body, { childList: true, subtree: true });

document.addEventListener('pointerdown', (e) => {
  const fader = e.target.closest?.('[data-pag-fader]');
  if (!fader) return;
  const move = (ev) => {
    const r = fader.getBoundingClientRect();
    setPos(fader, ((ev.clientY - r.top) / r.height * fader.clientHeight - CAP_H / 2) / (fader.clientHeight - CAP_H));
  };
  fader.setPointerCapture(e.pointerId);
  move(e);
  fader.addEventListener('pointermove', move);
  fader.addEventListener('pointerup', () => fader.removeEventListener('pointermove', move), { once: true });
});

document.addEventListener('wheel', (e) => {
  const group = e.target.closest?.('.pag-bp__group');
  const scroll = group?.querySelector('[data-pag-scroll]');
  if (!scroll || e.ctrlKey || !room(scroll)) return;
  const atEnd = e.deltaY > 0 ? scroll.scrollTop >= room(scroll) - 1 : scroll.scrollTop <= 0;
  if (atEnd) return;
  e.preventDefault();
  scroll.scrollTop += e.deltaY;
}, { passive: false });

document.addEventListener('keydown', (e) => {
  const fader = e.target.closest?.('[data-pag-fader]');
  if (!fader) return;
  const scroll = scrollOf(fader);
  const p = room(scroll) ? scroll.scrollTop / room(scroll) : 0;
  const step = { ArrowDown: 0.05, ArrowUp: -0.05, PageDown: 0.25, PageUp: -0.25 }[e.key];
  if (e.key === 'Home') setPos(fader, 0);
  else if (e.key === 'End') setPos(fader, 1);
  else if (step) setPos(fader, p + step);
  else return;
  e.preventDefault();
}); 

// Native scrolling (wheel, tabbing to a hidden brand) keeps the cap in step.
document.addEventListener('scroll', (e) => {
  if (syncing || !e.target.matches?.('[data-pag-scroll]')) return;
  paint(faderOf(e.target));
}, true);

// Opening or closing a filter group changes the scroll room without a scroll event.
document.addEventListener('toggle', () => document.querySelectorAll('[data-pag-fader]').forEach(paint), true);
